// extracted by mini-css-extract-plugin
export var card = "Projects-module--card--1YZA0";
export var animFade = "Projects-module--animFade--1S0hm";
export var fade = "Projects-module--fade--2OSqS";
export var animRight100 = "Projects-module--animRight100--2eBf9";
export var right100 = "Projects-module--right100--2SAHg";
export var animLeft100 = "Projects-module--animLeft100--Fa1Kd";
export var left100 = "Projects-module--left100--RN9Ji";
export var animRight200 = "Projects-module--animRight200--JfnYO";
export var right200 = "Projects-module--right200--S9Szd";
export var animLeft200 = "Projects-module--animLeft200--SzGnP";
export var left200 = "Projects-module--left200--3F-bv";
export var animDown100 = "Projects-module--animDown100--2FbvN";
export var down100 = "Projects-module--down100--oStao";
export var animTop100 = "Projects-module--animTop100--3-Z5C";
export var top100 = "Projects-module--top100--1maTz";